import { LTS_ERROR_CODE, TRAIN_LTS_PAGENAME } from '../pages/LiveTrainStatus/constants/LtsTrackingConstants';
import { PROP_61, PROP_62, PROP_63, PROP_64 } from './omnitureUtilConstants';
import { getPageSectionName } from './getPageSectionName';
import { SEO_ROUTE_PAGE } from './RailsSEOConstants';
import delayedScheduler from './scheduler';

export const getStaticPageLoadEvent = (pageName) =>
  `var s=s_gi('mmtprod');
      s.pageName="${pageName}";
      s.channel="seo";
      s.server = window.location.hostname;
      s.prop24="domestic rails";
      if(typeof(mboxLoadSCPlugin) != "undefined" ){
        mboxLoadSCPlugin(s);
      }
      var s_code=s.t();delayedScheduler(() => {if(s_code)document.write(s_code);});`;

export const trackClickEventLTS = (eventName, propVal) => {
  const pageName = TRAIN_LTS_PAGENAME;
  try {
    delayedScheduler(() => {
      const { s } = window;
      s.pageName = pageName;
      s.linkTrackVars = 'channel,eVar15,prop61,prop62,prop63,prop64';
      s.eVar15 = pageName;

      switch (propVal) {
        case PROP_61:
          s.prop61 = eventName;
          break;
        case PROP_62:
          s.prop62 = eventName;
          break;
        case PROP_63:
          s.prop63 = eventName;
          break;
        case PROP_64:
          s.prop64 = eventName;
          break;
      }

      s.tl(window, pageName, eventName);
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(LTS_ERROR_CODE);
  }
};

export const trackClickEventProp61 = (pageName, eventName) => {
  const pageSectionName = getPageSectionName(pageName);
  const ERROR_CODE = `SEO_${pageSectionName} page_load_error`;
  try {
    delayedScheduler(() => {
      const { s } = window;
      s.pageName = pageName;
      s.linkTrackVars = 'channel,eVar15,prop61';
      s.eVar15 = pageName;
      s.prop61 = eventName;

      s.tl(window, pageName, eventName);
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(ERROR_CODE);
  }
};

export const trackClickEventProp54 = (eventName) => {
  const pageName = SEO_ROUTE_PAGE;
  const pageSectionName = getPageSectionName(pageName);
  const ERROR_CODE = `SEO_${pageSectionName} page_load_error`;
  try {
    delayedScheduler(() => {
      const { s } = window;
      s.pageName = pageName;
      s.linkTrackVars = 'channel,prop54';
      s.prop54 = eventName;

      s.tl(window, pageName, eventName);
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(ERROR_CODE);
  }
};

export const trackViewEvent = (eventName) => {
  const pageName = SEO_ROUTE_PAGE;
  const pageSectionName = getPageSectionName(pageName);
  const ERROR_CODE = `SEO_${pageSectionName} page_load_error`;
  try {
    delayedScheduler(() => {
      const { s } = window;
      s.pageName = pageName;
      s.linkTrackVars = 'channel,eVar47';
      s.eVar47 = eventName;
      s.tl(window, pageName, eventName);
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(ERROR_CODE);
  }
};

export const trackLanguageSwitch = (pageName, fromLang, toLang) => {
  const ERROR_CODE = `SEO_language_error`;
  try {
    delayedScheduler(() => {
      const { s } = window;
      const eventName = `${pageName}_header_${fromLang}_to_${toLang}_switched`;
      s.m_c67 = eventName;
      s.pageName = pageName;
      s.tl(window, pageName, eventName);
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(ERROR_CODE);
  }
};
